// IE 2026 09 28 / ODOO-… (замечание Игоря: зависает меню угла виджета) — p219: страж формы левого верхнего угла виджета
// (⋯-форма Widget.vue: флаг show_commandPanel_topLeft; ✕ / ⤢ / ряды кнопок / Header · Tabs · Panel · Float / W · H / Free).
//
// Почему форма «зависала» (замер пробой tools/probes/topleftstuck_check.mjs на dev02, fe-2026-09-27-25, журнал — ANALYSIS.md):
//  - закрытие формы держалось на mouseleave самой формы (и на слежении за зоной, которое запускал только этот mouseleave); браузер шлёт
//    mouseleave, только если курсор хоть раз «вошёл» в форму — а при показе формы не под курсором (Float: форма под островком заголовка),
//    при уходе курсора в окне ~40 мс между показом (таймер 50 мс) и hover-обновлением браузера, при выходе курсора за окно и при возврате
//    на страницу KeepAlive mouseenter / mouseleave формы не приходят вовсе — форма оставалась открытой навсегда;
//  - решение показать форму принималось по последним координатам store.mouseX / Y (всплывающий mousemove на document) без проверки,
//    что курсор ещё на углу и угол не накрыт: форма открывалась после выхода курсора за окно и «сама» — когда панель-меню над углом
//    закрывали Esc (hover-обновление браузера шлёт mouseenter углу под неподвижным курсором).
//
// Как теперь: форма живёт, пока курсор в зоне «угол + форма (+ панель Settings | Variants, открытая из её бейджа)» — проверка по координатам
// глобального pointermove (window, capture — его не глушит stopPropagation редакторов) и elementFromPoint, при каждом движении мыши (раз в кадр),
// а не по одному mouseleave. Показ — только если последнее РЕАЛЬНОЕ движение мыши было над самим углом и угол сверху (не накрыт панелью,
// подсказкой, другим виджетом), курсор в окне. Форма закрывается (решение — в ближайшем кадре после выдержки, по свежим координатам):
// курсор вне зоны 150 мс (с mouseleave формы — 50 мс, как раньше);
// курсор в зоне над чужим виджетом / панелью-меню / формой ячейки / диалогом 600 мс (проход через чужое по пути к кнопке — не закрывает);
// открылась панель-меню или Alt+Tab (событие ie-overlay-open);
// потеря фокуса окна, скрытие вкладки; уход со страницы (deactivated KeepAlive); прокрутка контейнера виджета; Esc (курсор над формой —
// событие гасится, активный виджет не закрывается; открыта панель Settings | Variants из бейджа — первым Esc закрывается она; фокус в поле
// ввода — Esc ему: в самой форме (правка заголовка в слоте) форма остаётся, вне формы (правка ячейки) форма закрывается, событие идёт дальше).
// Одновременно открыта одна форма (открытие другой закрывает прежнюю). Мобильный профиль не трогается (там своё открытие тапом).
// Выключатель — настройка базы / браузера fe.ux.widgetCornerFormGuard (по умолчанию вкл; false — прежнее поведение целиком).
// Счётчики и состояние — window.__cornerFormGuard (stats, forms, version).

const HOLD_MS = 150        // курсор вне зоны — закрыть через (то же, что прежнее слежение за зоной)
const LEAVE_MS = 50        // mouseleave формы и курсор вне зоны — закрыть через (как прежний onClose_commandPanel_topLeft)
// IE 2026 09 28 / ODOO-… (p219, фаза B): курсор в геометрической зоне, но над ЧУЖИМ элементом — закрыть через 600 мс, а не 50 / 150.
// Замер пробы на dev (R1h_001): форму свободного виджета «Supply Chain Flow» частично накрывает другой свободный виджет; прямой путь от
// угла к кнопке Free идёт ~100 мс над ним — браузер шлёт mouseleave, и форма закрывалась через 50 мс (прежний код держал её по
// геометрической зоне). Проход через чужое по пути к кнопке формы форму не закрывает; остался над чужим — закрывается.
const FOREIGN_MS = 600
// «чужое» под курсором внутри геометрической зоны (другой виджет, панель-меню, форма ячейки, Alt+Tab, диалог)
const FOREIGN = '.WIDGET, .menu-panel, .dropdown, .chips-dropdown, .alt-tab-backdrop, .alt-tab-switcher, .p-dialog-mask, .p-dialog, .rh-dialog-mask, .layout-sidebar, .wj-dropdown-panel, .wj-popup, .p-overlaypanel'

const cornerFormGuard = {
    version: 'p219-3',
    store: null,
    forms: new Set(),            // открытые формы: прокси компонентов Widget
    x: null, y: null,            // последнее реальное движение мыши (clientX / Y)
    moveEl: null,                // элемент под курсором при последнем движении (target pointermove)
    inWin: true,                 // курсор в окне (mouseout с relatedTarget = null — вышел)
    stats: { opened: 0, closed: 0, byReason: {}, showBlocked: {} },
    _installed: false, _raf: 0, _timers: new Map(),

    // включён ли страж (десктоп, настройка не выключена)
    on(vm) {
        const s = (vm && vm.store) || this.store
        try {
            if (s && s.mobileUi && s.mobileUi.on) return false
            return !s || s.setting('fe.ux.widgetCornerFormGuard', true) !== false
        } catch (e) { return true }
    },

    install(store) {
        if (store && !this.store) this.store = store
        if (this._installed || typeof window === 'undefined') return
        this._installed = true
        const g = this
        g._onMove = (e) => {
            g.x = e.clientX; g.y = e.clientY; g.moveEl = e.target; g.inWin = true
            if (g.forms.size) g._schedule()
        }
        g._onOut = (e) => { if (!e.relatedTarget) { g.inWin = false; if (g.forms.size) g._schedule() } }
        g._onOver = (e) => { if (!e.relatedTarget) g.inWin = true }
        g._onBlur = () => g.closeAll('blur')
        g._onVis = () => { if (document.hidden || document.visibilityState === 'hidden') g.closeAll('hidden') }
        g._onScroll = (e) => {
            if (!g.forms.size) return
            const t = e.target
            for (const vm of [...g.forms]) {
                const el = vm.$el
                if (!el) continue
                // прокрутилась страница / контейнер, в котором лежит виджет (виджет уехал из-под курсора); прокрутка внутри виджета (грид) — нет
                if (t === document || t === document.documentElement || t === document.body || (t && t.contains && t !== el && t.contains(el) && !el.contains(t))) g.close(vm, 'scroll')
            }
        }
        g._onKey = (e) => {
            if (e.key !== 'Escape' || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || !g.forms.size) return
            let consumed = false
            const ae = document.activeElement
            // фокус в поле ввода / редакторе: Esc — ему (отмена правки заголовка в слоте формы, отмена правки ячейки)
            const editable = !!(ae && ae !== document.body && (ae.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName || '')))
            for (const vm of [...g.forms]) {
                if (!g.on(vm)) continue
                const form = vm.$el && vm.$el.querySelector && vm.$el.querySelector('.widget-commandPanel-top-left')
                const focusIn = !!(form && ae && form.contains(ae))
                if (editable && focusIn) continue                         // правка поля в самой форме (заголовок, W / H) — форма остаётся, Esc уходит полю
                const mine = !editable && (g.inside(vm) || focusIn)     // правка ВНЕ формы — форма закрывается, событие не гасится
                if (mine && vm.identInForm && vm.showDropdown) { vm.showDropdown = false; consumed = true; continue }   // первым Esc — панель Settings | Variants из бейджа формы
                g.close(vm, 'esc')
                if (mine) consumed = true
            }
            if (consumed) { g.stats.escConsumed = (g.stats.escConsumed || 0) + 1; e.stopPropagation(); e.preventDefault() }   // курсор над формой — Esc закрыл её, активный виджет не закрывается (App.handleKeydown)
        }
        g._onOverlay = (e) => g.closeAll('overlay:' + ((e && e.detail && e.detail.kind) || '?'))
        window.addEventListener('pointermove', g._onMove, { capture: true, passive: true })
        document.addEventListener('mouseout', g._onOut, true)
        document.addEventListener('mouseover', g._onOver, true)
        window.addEventListener('blur', g._onBlur)
        document.addEventListener('visibilitychange', g._onVis)
        window.addEventListener('scroll', g._onScroll, { capture: true, passive: true })
        window.addEventListener('keydown', g._onKey, true)
        window.addEventListener('ie-overlay-open', g._onOverlay)
        window.__cornerFormGuard = g
    },

    // можно ли показать форму: вызывается таймером показа Widget.onShow_commandPanel_topLeft вместо store.mouse_isInside(угол)
    canShow(vm, target) {
        this.install(vm && vm.store)
        if (!this.on(vm)) return vm.store.mouse_isInside(target)   // выключатель — прежняя проверка
        if (!target || !target.isConnected) return this._blocked('detached')
        // до первого движения мыши после загрузки координат нет — прежняя проверка
        if (this.x == null) return vm.store.mouse_isInside(target)
        if (!this.inWin) return this._blocked('out-of-window')
        const r = target.getBoundingClientRect()
        if (!(this.x >= r.left && this.x <= r.right && this.y >= r.top && this.y <= r.bottom)) return this._blocked('moved-away')
        // последнее реальное движение было над самим углом (или формой): mouseenter от hover-обновления браузера под неподвижным курсором
        // (закрыли панель-меню над углом) формы не открывает
        if (!(this.moveEl && (this.moveEl === target || target.contains(this.moveEl)))) return this._blocked('no-real-move')
        const hit = document.elementFromPoint(this.x, this.y)
        if (!(hit && (hit === target || target.contains(hit)))) return this._blocked('covered')   // угол накрыт панелью / подсказкой / другим виджетом
        return true
    },
    _blocked(why) { this.stats.showBlocked[why] = (this.stats.showBlocked[why] || 0) + 1; return false },

    // вотчер флага show_commandPanel_topLeft (Widget.vue watch)
    sync(vm, open) {
        this.install(vm && vm.store)
        if (!open || !this.on(vm)) { this._drop(vm); return }
        if (this.forms.has(vm)) return
        for (const other of [...this.forms]) if (other !== vm) this.close(other, 'another-form')   // одна форма за раз
        this.forms.add(vm)
        this.stats.opened++
        this._schedule()   // курсор мог уйти, пока форма рисовалась
    },

    // mouseleave формы (Widget.onClose_commandPanel_topLeft при включённом страже)
    leave(vm, e) {
        this.install(vm && vm.store)
        if (e && typeof e.clientX === 'number') { this.x = e.clientX; this.y = e.clientY }
        if (!this.forms.has(vm)) { if (vm.show_commandPanel_topLeft && this.on(vm)) this.forms.add(vm); else return }
        this._judge(vm, LEAVE_MS)
    },

    // уход со страницы (KeepAlive deactivated): форма закрывается, иначе после возврата она открыта без курсора
    deactivated(vm) { if (vm && vm.show_commandPanel_topLeft && this.on(vm)) this.close(vm, 'deactivated') },

    // положение курсора относительно зоны удержания формы: 'in' — своё под курсором, 'foreign' — в геометрической зоне, но над чужим
    // элементом, 'out' — вне зоны / вне окна / виджет отсоединён (IE 2026 09 28 / ODOO-… (p219, фаза B): 'foreign' отделён от 'out' — FOREIGN_MS)
    zone(vm) {
        if (!this.inWin || this.x == null || !vm || !vm.$el || !vm.$el.isConnected) return 'out'
        const z = vm.topLeftZone_rect && vm.topLeftZone_rect()
        if (!z || !(this.x >= z.left && this.x <= z.right && this.y >= z.top && this.y <= z.bottom)) return 'out'
        const hit = document.elementFromPoint(this.x, this.y)
        if (!hit) return 'out'
        if (vm.$el.contains(hit)) return 'in'                         // форма, угол, свой виджет, панель Settings | Variants из бейджа (цель телепорта в виджете)
        if (hit.closest && hit.closest('.wj-tooltip')) return 'in'    // доживающая Alt-подсказка кнопки формы (как у панелей-меню)
        if (hit.closest && hit.closest(FOREIGN)) return 'foreign'     // чужой виджет, панель-меню, форма ячейки, Alt+Tab, диалог
        return 'in'                                                   // поле зоны вне виджета (зазор страницы, край шапки / рейла)
    },
    // курсор в зоне удержания формы (своё под курсором)
    inside(vm) { return this.zone(vm) === 'in' },

    check() {
        for (const vm of [...this.forms]) this._judge(vm, HOLD_MS)
    },
    _judge(vm, delay) {
        if (!vm.show_commandPanel_topLeft) { this._drop(vm); return }
        if (!vm.$el || !vm.$el.isConnected) { this.close(vm, 'detached'); return }
        if (vm.identInForm && vm.showDropdown) { this._cancel(vm); return }   // открыта панель из бейджа формы — форма держится, пока открыта панель (23.09)
        const st = this.zone(vm)
        if (st === 'in') { this._cancel(vm); return }
        const d = st === 'foreign' ? FOREIGN_MS : delay
        const cur = this._timers.get(vm)
        if (cur && cur.d <= d) return          // закрытие уже назначено с той же или меньшей выдержкой
        if (cur) clearTimeout(cur.id)           // курсор ушёл из зоны, пока шла выдержка над чужим, — короткая выдержка главнее
        // IE 2026 09 28 / ODOO-… (p219, фаза B): решение — в ближайшем кадре. После долгой задачи (на тяжёлой странице 0,5–1 с) таймер срабатывает
        // раньше, чем браузер раздаст накопившиеся движения мыши (они приходят в начале кадра), — по устаревшим координатам форма закрывалась
        // на проходе через чужой виджет. Запись таймера живёт до решения: новые движения не перевзводят его (иначе движение вне зоны
        // откладывало бы закрытие бесконечно); возврат курсора в зону её снимает (_cancel), более короткая выдержка — заменяет.
        const entry = { id: 0, d }
        entry.id = setTimeout(() => {
            if (this._timers.get(vm) !== entry) return
            entry.id = 0
            const decide = () => {
                if (this._timers.get(vm) !== entry) return          // отменено (курсор вернулся) или заменено более коротким решением
                this._timers.delete(vm)
                if (!this.forms.has(vm) || !vm.show_commandPanel_topLeft) return
                if (vm.identInForm && vm.showDropdown) return
                const now = this.zone(vm)
                if (now === 'in') return
                if (now === 'foreign' && st !== 'foreign') { this._judge(vm, delay); return }   // вернулся в зону, но над чужим — отсчёт заново (FOREIGN_MS)
                this.close(vm, now === 'foreign' ? 'foreign' : (delay === LEAVE_MS ? 'mouseleave' : 'left-zone'))
            }
            if (typeof requestAnimationFrame === 'function') requestAnimationFrame(decide); else decide()
        }, d)
        this._timers.set(vm, entry)
    },
    _schedule() {
        if (this._raf) return
        const run = () => { this._raf = 0; this.check() }
        this._raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame(run) : setTimeout(run, 16)
    },
    _cancel(vm) { const t = this._timers.get(vm); if (t) { if (t.id) clearTimeout(t.id); this._timers.delete(vm) } },
    _drop(vm) { this._cancel(vm); this.forms.delete(vm) },

    close(vm, reason) {
        this._drop(vm)
        if (!vm || !vm.show_commandPanel_topLeft) return
        this.stats.closed++
        this.stats.byReason[reason] = (this.stats.byReason[reason] || 0) + 1
        try { vm.forceCloseTopLeft() } catch (e) { vm.show_commandPanel_topLeft = false }
    },
    closeAll(reason) { for (const vm of [...this.forms]) this.close(vm, reason) },
}

export default cornerFormGuard
